import {
  UIActionTypes,
  UIState,
  DifficultyLevel,
  DesignTab,
  GameStats,
  SettingsState,
  IndicatorsState,
  Checkboxes,
  UpdateGameStatsAction,
  SetDifficultyAction,
  IncrementMovesAction,
  UpdateTimeAction,
  ResetGameStatsAction,
  OpenDesignModalAction,
  CloseDesignModalAction,
  SetDesignTabAction,
  OpenSettingsModalAction,
  CloseSettingsModalAction,
  ToggleSettingAction,
  UpdateSettingsAction,
  SetPatternAction,
  SetCardThemeAction,
  SetBackgroundAction,
  SetIndicatorAction,
  SetHintsCountAction,
  ShareButtonClickedAction,
  TutorialButtonClickedAction,
  MagicWandClickedAction,
  AutocompleteClickedAction,
  CloseAllPanelsAction
} from '../../types/gameUI';

// Universal action creator for updating any part of UI state
export const updateUIState = (payload: Partial<UIState>) => ({
  type: UIActionTypes.UPDATE_UI_STATE,
  payload
} as const);

// Game Stats Actions
export const updateGameStats = (stats: Partial<GameStats>): UpdateGameStatsAction => ({
  type: UIActionTypes.UPDATE_GAME_STATS,
  payload: stats
});

export const setDifficulty = (difficulty: DifficultyLevel): SetDifficultyAction => ({
  type: UIActionTypes.SET_DIFFICULTY,
  payload: difficulty
});

export const incrementMoves = (): IncrementMovesAction => ({
  type: UIActionTypes.INCREMENT_MOVES
});

export const updateTime = (time: number): UpdateTimeAction => ({
  type: UIActionTypes.UPDATE_TIME,
  payload: time
});

export const resetGameStats = (): ResetGameStatsAction => ({
  type: UIActionTypes.RESET_GAME_STATS
});

// Modals Actions
export const openDesignModal = (tab?: DesignTab): OpenDesignModalAction => ({
  type: UIActionTypes.OPEN_DESIGN_MODAL,
  payload: tab
});

export const closeDesignModal = (): CloseDesignModalAction => ({
  type: UIActionTypes.CLOSE_DESIGN_MODAL
});

export const setDesignTab = (tab: DesignTab): SetDesignTabAction => ({
  type: UIActionTypes.SET_DESIGN_TAB,
  payload: tab
});

export const openSettingsModal = (): OpenSettingsModalAction => ({
  type: UIActionTypes.OPEN_SETTINGS_MODAL
});

export const closeSettingsModal = (): CloseSettingsModalAction => ({
  type: UIActionTypes.CLOSE_SETTINGS_MODAL
});

export const closeAllPanels = (): CloseAllPanelsAction => ({
  type: UIActionTypes.CLOSE_ALL_PANELS
});

// Settings Actions
export const toggleSetting = (key: string): ToggleSettingAction => ({
  type: UIActionTypes.TOGGLE_SETTING,
  payload: key
});

export const updateSettings = (settings: Checkboxes[]): UpdateSettingsAction => ({
  type: UIActionTypes.UPDATE_SETTINGS,
  payload: settings
});

// Design Actions
export const setPattern = (pattern: string): SetPatternAction => ({
  type: UIActionTypes.SET_PATTERN,
  payload: pattern
});

export const setCardTheme = (theme: string): SetCardThemeAction => ({
  type: UIActionTypes.SET_CARD_THEME,
  payload: theme
});

export const setBackground = (background: string): SetBackgroundAction => ({
  type: UIActionTypes.SET_BACKGROUND,
  payload: background
});

// Indicators Actions
export const setIndicator = (key: keyof IndicatorsState, value: boolean | number): SetIndicatorAction => ({
  type: UIActionTypes.SET_INDICATOR,
  payload: { key, value }
});

export const setHintsCount = (count: number): SetHintsCountAction => ({
  type: UIActionTypes.SET_HINTS_COUNT,
  payload: count
});

// Button Actions
export const shareButtonClicked = (): ShareButtonClickedAction => ({
  type: UIActionTypes.SHARE_BUTTON_CLICKED
});

export const tutorialButtonClicked = (): TutorialButtonClickedAction => ({
  type: UIActionTypes.TUTORIAL_BUTTON_CLICKED
});

export const magicWandClicked = (): MagicWandClickedAction => ({
  type: UIActionTypes.MAGIC_WAND_CLICKED
});

export const autocompleteClicked = (): AutocompleteClickedAction => ({
  type: UIActionTypes.AUTOCOMPLETE_CLICKED
}); 